/* eslint-disable @next/next/no-img-element */
import React, { ReactElement } from "react";
import { useAppContext } from "@kunduz/feature-website-context";
import { trackEvent } from "@kunduz/utility-analytics";
import StupidArrow from "@icons/ropeInstallApp.svg";
import styles from "./questionSideCta.module.scss";
import { useTranslation } from "next-i18next";
import type { QuestionIndexing } from "@kunduz/data-access-qi-api";
import { useStudentLimits } from "@kunduz/data-access-core-api";
import QRCode from "react-qr-code";

const InstallTheAppCta = (props: Props): ReactElement => {
  const { kunduzApiToken } = useAppContext();
  const { studentLimits } = useStudentLimits(kunduzApiToken);
  const { t } = useTranslation("questionIndexing");

  function onDownloadClicked(clicked_item) {
    trackEvent("Question Indexing App Download Button Clicked", {
      course: props.question?.course?.slug,
      subject: props.question?.subject?.slug,
      page_slug: window.location.pathname,
      remaining_answer_credit: studentLimits?.questions?.remained,
      initial_answer_credit: studentLimits?.questions?.total,
      destination_url: props.question?.branch_io_link,
      clicked_item,
      type: "sidebar",
    });
  }

  return (
    <div className={styles.installAppCta}>
      <p className={styles.title}>{props.title}</p>

      <div className={styles.qrLine}>
        <div className={styles.qrWrapper}>
          <QRCode value={props.qrCodeLink} size={78} />
        </div>
        <StupidArrow className={styles.stupidArrow} />
        <span>{props.qrLabel}</span>
      </div>

      <ul className={styles.list}>
        <li>{props.firstBenefit}</li>
        <li>{props.secondBenefit}</li>
        <li>{props.thirdBenefit}</li>
        <li>{props.fourthBenefit}</li>
      </ul>

      <div className={styles.appStoreLogoWrapper}>
        <a
          target="_blank"
          rel="noreferrer"
          href={props.appStoreLink}
          onClick={() => onDownloadClicked("app_store")}
        >
          <img loading="lazy" src="/images/applestore.webp" alt="app_store" />
        </a>
        <a
          target="_blank"
          rel="noreferrer"
          href={props.playStoreLink}
          onClick={() => onDownloadClicked("play_store")}
        >
          <img loading="lazy" src="/images/googleplay.webp" alt="play_store" />
        </a>
      </div>
    </div>
  );
};

interface Props {
  question?: QuestionIndexing.TrQiQuestion;
  title: string;
  qrLabel: string;
  firstBenefit: string;
  secondBenefit: string;
  thirdBenefit: string;
  fourthBenefit: string;
  appStoreLink: string;
  playStoreLink: string;
  qrCodeLink: string;
}

export default InstallTheAppCta;
